import { AubadeComponent } from "js/front/bootstrap/AubadeComponent";
import gsap from "gsap";

import { facebookShare, twitterShare, pinterestShare, mailShare } from "libs";

export class ShareProject extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        this.background = this.element.querySelector(
            "#background-main-gradient"
        );
        this.foreground = this.element.querySelector(".fps-foreground");
        this.content = this.element.querySelector(".fps-content");

        this.input = this.element.querySelector(".link input");
        this.copyBtn = this.element.querySelector(".link .copy");

        this.fbBtn = this.element.querySelector(".shares .fb");
        this.twBtn = this.element.querySelector(".shares .tw");
        this.ptBtn = this.element.querySelector(".shares .pt");
        this.mlBtn = this.element.querySelector(".shares .ml");
        this.body = document.querySelector("body");
    }

    attach() {
        this.element.addEventListener("click", this.hide);
        this.content.addEventListener("click", this.prevent);
        this.copyBtn.addEventListener("click", this.copyLink);
        this.fbBtn.addEventListener("click", this.onFbShare);
        this.twBtn.addEventListener("click", this.onTwShare);
        this.ptBtn.addEventListener("click", this.onPtShare);
        this.mlBtn.addEventListener("click", this.onMlShare);
    }

    detach() {
        this.element.removeEventListener("click", this.hide);
        this.content.removeEventListener("click", this.prevent);
        this.copyBtn.removeEventListener("click", this.copyLink);
        this.fbBtn.removeEventListener("click", this.onFbShare);
        this.twBtn.removeEventListener("click", this.onTwShare);
        this.ptBtn.removeEventListener("click", this.onPtShare);
        this.mlBtn.removeEventListener("click", this.onMlShare);
    }

    copyLink = () => {
        this.input.select();
        document.execCommand("copy");
    };

    onFbShare = () => {
        facebookShare(this.input.value);
    };

    onTwShare = () => {
        twitterShare(this.twBtn.dataset.text, this.input.value);
    };

    onPtShare = () => {
        pinterestShare(this.input.value);
    };

    onMlShare = () => {
        mailShare(this.mlBtn.dataset.subject, this.mlBtn.dataset.body);
    };

    prevent = e => {
        e.stopPropagation();
        e.stopImmediatePropagation();
    };

    show = () => {
        this.element.style.display = "block";
        const t = gsap.timeline();
        t.fromTo(
            [this.background, this.foreground],
            { opacity: 0 },
            { opacity: 1, duration: 0.5 },
            0
        );
        t.fromTo(
            this.content,
            { scale: 0.7 },
            { scale: 1, duration: 1, ease: "expo.out" },
            0
        );
        this.body.classList.add("modality-open");
        return t;
    };

    hide = () => {
        const t = gsap.timeline();

        t.to(
            [this.background, this.foreground],
            { opacity: 0, duration: 0.3 },
            0
        );
        t.to(this.content, { scale: 0.7, duration: 0.6, ease: "expo.out" }, 0);
        t.add(() => {
            this.element.style.display = "none";
        });
        this.body.classList.remove("modality-open");

        return t;
    };
}
